// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FormWrapperComponent from "@store/Library/Components/Toolkit/FormWrapper";
import React, { FC } from "react";

/* Store Custom Code - Start */
import StoreFormWrapper from "@store/Library/Components/Foundation/StoreForm/StoreFormWrapper";
/* Store Custom Code - End */

interface Props extends WidgetProps {}

const FormWrapper: FC<Props> = ({ id }) => {
    return (
        <StoreFormWrapper /* Store Custom Code */>
            <Zone contentId={id} zoneName="Content" />
        </StoreFormWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: FormWrapper,
    definition: {
        group: "Basic",
        icon: "universal-access",
        displayName: "Form Wrapper",
    },
};

export default widgetModule;
